import CannedVegsFruitsProduct from 'models/CannedVegsFruitsProduct'

export const packagingInitialState = {
  category: CannedVegsFruitsProduct.category,
  subCategory: CannedVegsFruitsProduct.subCategory,
  ItemType: {
    value: '',
    label: 'Type',
  },
  Size: '',
  ContainerType: {
    value: '',
    label: 'Container Type',
  },
  packageType: {
    value: '',
    label: 'Package Type',
  },
  MultiPackageType: CannedVegsFruitsProduct.MultiPackageType,
  MultiPackageCount: CannedVegsFruitsProduct.MultiPackageCount,
  noAddtlIngredients: false,
  OrganicVerification: false,
  CannedProductType: 'Fruit',
  otherType: '',
  otherContainerType: '',
}

export const productTypeOptions = ['Fruit', 'Vegetable']

export const fruitTypeOptions = [
  {
    value: '',
    label: 'Fruit Type',
    isDisabled: true,
  },
  { value: 'Apple', label: 'Apple' },
  { value: 'Applesauce', label: 'Applesauce' },
  { value: 'Apricot', label: 'Apricot' },
  { value: 'Banana', label: 'Banana' },
  { value: 'Blackberry', label: 'Blackberry' },
  { value: 'Blueberry', label: 'Blueberry' },
  { value: 'Cherry', label: 'Cherry' },
  { value: 'Coconut', label: 'Coconut' },
  { value: 'Cranberry', label: 'Cranberry' },
  { value: 'Currant', label: 'Currant' },
  { value: 'Date', label: 'Date' },
  { value: 'Fig', label: 'Fig' },
  { value: 'Grape', label: 'Grape' },
  { value: 'Grapefruit', label: 'Grapefruit' },
  { value: 'Guava', label: 'Guava' },
  { value: 'Kiwi', label: 'Kiwi' },
  { value: 'Lemon', label: 'Lemon' },
  { value: 'Lime', label: 'Lime' },
  { value: 'Mandarin', label: 'Mandarin' },
  { value: 'Mango', label: 'Mango' },
  { value: 'Melon', label: 'Melon' },
  { value: 'Mixed Fruit', label: 'Mixed Fruit' },
  { value: 'Mulberry', label: 'Mulberry' },
  { value: 'Nectarine', label: 'Nectarine' },
  { value: 'Orange', label: 'Orange' },
  { value: 'Papaya', label: 'Papaya' },
  { value: 'Passionfruit', label: 'Passionfruit' },
  { value: 'Peach', label: 'Peach' },
  { value: 'Peacharine', label: 'Peacharine' },
  { value: 'Pear', label: 'Pear' },
  { value: 'Pineapple', label: 'Pineapple' },
  { value: 'Plum', label: 'Plum' },
  { value: 'Pluot', label: 'Pluot' },
  { value: 'Pomegranate', label: 'Pomegranate' },
  { value: 'Prune', label: 'Prune' },
  { value: 'Raisin', label: 'Raisin' },
  { value: 'Raspberry', label: 'Raspberry' },
  { value: 'Strawberry', label: 'Strawberry' },
  { value: 'Tangelo', label: 'Tangelo' },
  { value: 'Tangerine', label: 'Tangerine' },
  { value: 'Watermelon', label: 'Watermelon' },
  { value: 'Youngberry', label: 'Youngberry' },
  {
    value: 'Other',
    label: 'Other',
  },
]

export const vegTypeOptions = [
  {
    value: '',
    label: 'Vegetable Type',
    isDisabled: true,
  },
  { value: 'Artichoke', label: 'Artichoke' },
  { value: 'Asparagus', label: 'Asparagus' },
  { value: 'Avocado', label: 'Avocado' },
  { value: 'Bamboo', label: 'Bamboo' },
  { value: 'Beanette', label: 'Beanette' },
  { value: 'Bean, Green', label: 'Bean, Green' },
  { value: 'Bean, Lima', label: 'Bean, Lima' },
  { value: 'Bean, Other', label: 'Bean, Other' },
  { value: 'Beet', label: 'Beet' },
  { value: 'Blackeye Pea', label: 'Blackeye Pea' },
  { value: 'Broccoflower', label: 'Broccoflower' },
  { value: 'Broccoli', label: 'Broccoli' },
  { value: 'Brussels Sprout', label: 'Brussels Sprout' },
  { value: 'Cabbage', label: 'Cabbage' },
  { value: 'Carrot', label: 'Carrot' },
  { value: 'Cauliflower', label: 'Cauliflower' },
  { value: 'Celery', label: 'Celery' },
  { value: 'Chili', label: 'Chili' },
  { value: 'Chive', label: 'Chive' },
  { value: 'Choy', label: 'Choy' },
  { value: 'Corn', label: 'Corn' },
  { value: 'Cress', label: 'Cress' },
  { value: 'Cucumber', label: 'Cucumber' },
  { value: 'Eggplant', label: 'Eggplant' },
  { value: 'Endive', label: 'Endive' },
  { value: 'Garlic', label: 'Garlic' },
  { value: 'Gourd', label: 'Gourd' },
  { value: 'Green', label: 'Green' },
  { value: 'Hominy', label: 'Hominy' },
  { value: 'Leek', label: 'Leek' },
  { value: 'Mixed Vegetable', label: 'Mixed Vegetable' },
  { value: 'Mushroom', label: 'Mushroom' },
  { value: 'Okra', label: 'Okra' },
  { value: 'Onion', label: 'Onion' },
  { value: 'Pea', label: 'Pea' },
  { value: 'Pea, Sugar Snap', label: 'Pea, Sugar Snap' },
  { value: 'Pepper', label: 'Pepper' },
  { value: 'Pumpkin', label: 'Pumpkin' },
  { value: 'Radish', label: 'Radish' },
  { value: 'Rhubarb', label: 'Rhubarb' },
  { value: 'Spinach', label: 'Spinach' },
  { value: 'Sprout', label: 'Sprout' },
  { value: 'Squash', label: 'Squash' },
  { value: 'Sweet Potato', label: 'Sweet Potato' },
  { value: 'Tomato', label: 'Tomato' },
  { value: 'Watercress', label: 'Watercress' },
  { value: 'Zucchini', label: 'Zucchini' },
  {
    value: 'Other',
    label: 'Other',
  },
]

export const fruitContainerTypeOptions = [
  {
    value: '',
    label: 'Container Type',
    isDisabled: true,
  },
  {
    value: 'Can',
    label: 'Can',
  },
  {
    value: 'Cup',
    label: 'Cup',
  },
  {
    value: 'Glass',
    label: 'Glass',
  },
  {
    value: 'Jar',
    label: 'Jar',
  },
  {
    value: 'Pouch',
    label: 'Pouch',
  },
  {
    value: 'Other',
    label: 'Other',
  },
]

export const vegContainerTypeOptions = [
  {
    value: '',
    label: 'Container Type',
    isDisabled: true,
  },
  {
    value: 'Can',
    label: 'Can',
  },
  {
    value: 'Cup',
    label: 'Cup',
  },
  {
    value: 'Glass',
    label: 'Glass',
  },
  {
    value: 'Jar',
    label: 'Jar',
  },
  {
    value: 'Pouch',
    label: 'Pouch',
  },
  {
    value: 'Other',
    label: 'Other',
  },
]

export const fruitPackTypeOptions = [
  {
    value: '',
    label: 'Packed In',
    isDisabled: true,
  },
  {
    value: 'Water',
    label: 'Water',
  },
  {
    value: 'Juice',
    label: 'Juice',
  },
]

export const vegPackTypeOptions = [
  {
    value: '',
    label: 'Salt Content',
    isDisabled: true,
  },
  {
    value: 'Low Sodium',
    label: 'Low Sodium',
  },
  {
    value: 'No Salt',
    label: 'No Salt',
  },
  {
    value: 'Reg Salt',
    label: 'Reg Salt',
  },
]

export const fruitPackSizeOptions = [
  {
    value: '',
    label: 'Container Size',
    isDisabled: true,
  },
  {
    value: 'Single',
    label: 'Single',
  },
  {
    value: '2-Pack',
    label: '2-Pack',
  },
  {
    value: '3-Pack',
    label: '3-Pack',
  },
  {
    value: '4-Pack',
    label: '4-Pack',
  },
  {
    value: '6-Pack',
    label: '6-Pack',
  },
  {
    value: '8-Pack',
    label: '8-Pack',
  },
  {
    value: '12-Pack',
    label: '12-Pack',
  },
]

export const vegPackSizeOptions = [
  {
    value: '',
    label: 'Container Size',
    isDisabled: true,
  },
  {
    value: 'Single',
    label: 'Single',
  },
  {
    value: '2-Pack',
    label: '2-Pack',
  },
  {
    value: '3-Pack',
    label: '3-Pack',
  },
  {
    value: '4-Pack',
    label: '4-Pack',
  },
  {
    value: '6-Pack',
    label: '6-Pack',
  },
  {
    value: '8-Pack',
    label: '8-Pack',
  },
  {
    value: '12-Pack',
    label: '12-Pack',
  },
]

export const fruitProductOptions = {
  typeOptions: fruitTypeOptions,
  containerTypeOptions: fruitContainerTypeOptions,
  packTypeOptions: fruitPackTypeOptions,
  packSizeOptions: fruitPackSizeOptions,
  packTypeTitle: 'Packed in Water or Juice',
  packTypePlaceholder: 'Packed in Water or Juice',
  noAdditionalIngredients:
    'I certify that this product has NO added fats, oils, salt, or sugars.',
}

export const vegProductOptions = {
  typeOptions: vegTypeOptions,
  containerTypeOptions: vegContainerTypeOptions,
  packTypeOptions: vegPackTypeOptions,
  packSizeOptions: vegPackSizeOptions,
  packTypeTitle: 'Salt Content',
  packTypePlaceholder: 'Select Salt Content',
  noAdditionalIngredients: `I certify that this product has NO added fats, oils, or sugars 
    (sugar allowed in small amounts in certain products that require minimal sugar for the canning process), 
    and is not pickled, creamed, or sauced. 
    In addition, this product is not a soup, ketchup, relish, olive, salsa, stewed tomato or tomato sauce.`,
}
